import React from 'react'
import Toast from '../../containers/Toast'
import { ToastAction } from '../../reducers/toasts/actionNames'
import { IToast } from './fireToast'

const fireToastError = (
  message: string | React.ReactNode,
  delayClose: number | false = 5000,
  container = 'Main',
  toastId: string | number = undefined,
  withButton = false,
  buttonLabel = '',
  buttonCb: () => void = null,
  buttonIcon: any = null,
): IToast<ToastAction.FireToastError> => {
  //log function call stack
  console.warn('fireToastError', new Error().stack)

  return  {
    container,
    delayClose,
    message: (
      <Toast.Error
        buttonIcon={buttonIcon}
        withButton={withButton}
        buttonLabel={buttonLabel}
        buttonCb={buttonCb}
      >
        {message}
      </Toast.Error>
    ),
    toastId: toastId ? toastId : (message as string),
    type: ToastAction.FireToastError,
  }
}

export default fireToastError
